const baseType = [
  'any',
  'class',
  'literal',
  'library_ref',
  'semantic_not',
  'semantic_and'
];
const baseTypeMap = new Map();
baseType.forEach(type => baseTypeMap.set(type, type));

export { baseType, baseTypeMap };
